




























































import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { Directory } from "../../../../base/domain/drawing";
import {
  ISortParameter,
  Separator,
  EmptyComponent,
} from "../../../../base/components/system";
import {
  ModelEditableMixin
} from "../../../../base/components/system/mixins";
import {
  EditableFormatSummaryTreeFilterParameter,
  EditableFormatSummaryTreeFilter,
} from "../filters";
import {
  EditableFormatSummariesSelector,
} from "./trees";
import {
  ITreeSource,
  FormatTreeSource,
} from "./trees/sources";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { default as FormatSortSelector } from "./FormatSortSelector.vue";
import { default as FormatTableSelector } from "./FormatTableSelector.vue";
import { IConfiguration } from "../../../domain/configuration";

@Component({
  components: {
    EditableFormatSummaryTreeFilter,
    EditableFormatSummariesSelector,
    EmptyComponent,
    Separator,
    FormatSortSelector,
    FormatTableSelector,
  }
})
export default class FilterableFormatsSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  isShown: boolean;

  @Prop({ default: false })
  containsExpired: boolean;

  @Prop({ default: false })
  containsDeleted: boolean;

  isLoaded: boolean = false;
  formatFilter: EditableFormatSummaryTreeFilterParameter = new EditableFormatSummaryTreeFilterParameter();
  selectionOfAllFormats: EditableFormatSummary[] = [];
  allFormatTreeSource: ITreeSource<number, EditableFormatSummary> = new FormatTreeSource();
  isTreeSelecting: boolean = false;
  selectorWidth: number = 480;
  expandFilter: boolean = true;
  sortedValues: EditableFormatSummary[] = [];
  sortParameter: ISortParameter = null;
  shouldShowEmptyFolder: boolean;

  data(): any {
    return {
      shouldShowEmptyFolder: this.$configuration.formatEditor.behavior.format.list.filters.folder.shouldShowEmptyFolderDefault,
    };
  }

  $configuration!: IConfiguration;

  $refs!: {
    allFormatsSelector: EditableFormatSummariesSelector
  };

  mounted(): void {
    if (this.isShown) {
      this.isLoaded = true;
      this.loadFormatTree();
    }
  }

  @Watch("isShown")
  onIsShownUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue && !this.isLoaded) {
      this.isLoaded = true;
      this.loadFormatTree();
    }
  }

  loadFormatTree(): void {
    this.$refs.allFormatsSelector.loadTree();
  }

  get filterFormat(): (source: EditableFormatSummary | Directory<number, EditableFormatSummary>) => boolean {
    return this.createFormatFilter(this.formatFilter);
  }

  createFormatFilter(source: EditableFormatSummaryTreeFilterParameter): (source: EditableFormatSummary | Directory<number, EditableFormatSummary>) => boolean {
    return s => source.filter(s);
  }

  treeNodeSelectUpdated(value: boolean): void {
    this.isTreeSelecting = value;
  }

  cancelSelectFormatTree(): void {
    this.$refs.allFormatsSelector.cancelSelectFormatTree();
  }

  expandTree(): void {
    this.$refs.allFormatsSelector.expandTree();
  }

  get isEditFormatTree(): boolean {
    return true;
  }

  async editFormatTree(): Promise<void> {
    try {
      this.$emit("editingFormat", true);
      await this.$refs.allFormatsSelector.editFormatTree();
    } catch (e) {
      this.$logger.debug(e);
    }
    this.$emit("editingFormat", false);
  }

  onSortChanged(param: ISortParameter): void {
    this.sortParameter = param;
  }

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}

  @Watch("selectionOfAllFormats")
  onSelectionOfAllFormatsChanged(newValue: EditableFormatSummary[]) {
    this.folderSelectionChanged(newValue);
  }

  @Emit("folderSelectionChanged")
  folderSelectionChanged(formats: EditableFormatSummary[]): void {}
}
